/*global Modernizr, tec_get_percentageSeen, lottie, tec_lottie_capitol, tec_lottie_star */
/*jslint browser:true */

(function() {
  'use strict';

  var lottie_player_capitol = false,
      lottie_player_star = false;

  const lottie_capitol = document.getElementById('tec_lottie_capitol');
  if(lottie_capitol) {
    lottie_player_capitol = lottie.loadAnimation({
      container: lottie_capitol,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: tec_lottie_capitol
    });
  }

  const lottie_star = document.getElementById('tec_lottie_star');
  if(lottie_star) {
    lottie_player_star = lottie.loadAnimation({
      container: lottie_star,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: tec_lottie_star
    });
  }

  const handler = function() {
    if(lottie_player_capitol && tec_get_percentageSeen(lottie_capitol) > 30) {
      lottie_player_capitol.play();
    }

    if(lottie_player_star && tec_get_percentageSeen(lottie_star) > 30) {
      lottie_player_star.play();
    }
  };

  addEventListener('DOMContentLoaded', handler, false);
  addEventListener('load', handler, false);
  addEventListener('scroll', handler, false);
  addEventListener('resize', handler, false);
}());